/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React from "react";
import {
  Button,
  Grid,
  Item,
  Icon,
  Form,
  Input,
  Message,
} from "semantic-ui-react";
import { NavLink } from "react-router-dom";
import ApplicantForm from "./ApplicantForm";
import "./EnrollmentForm.css";

const EnrollmentFormPV = (props) => {
  if (props.auth) {
    props.logout();
  }
  return (
    <div>
      <style>
        {`
        html {
          background: url(/enrollment/4.png) no-repeat center center fixed;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        }
        body {
          overflow-x: hidden;
          background: none;
        }
      `}
      </style>
      <div className="enrollment-header">
        <Grid centered>
          <Grid.Column widescreen={10} computer={14} mobile={16}>
            <Grid columns={2}>
              <Grid.Column>
                <Item.Group className="orgid" unstackable>
                  <Item>
                    <Item.Content>
                      <Item.Header>
                        <h1
                          style={{
                            paddingTop: "3px",
                            fontSize: "1.4em",
                            color: "#000000",
                          }}
                        >
                          SALIS Enrollment
                        </h1>
                      </Item.Header>
                    </Item.Content>
                  </Item>
                </Item.Group>
              </Grid.Column>
              <Grid.Column textAlign="right" style={{ paddingTop: "25px" }}>
                <NavLink key="enr" to="/enrollment">
                  <Icon name="home" />
                  <span
                    style={{
                      veticalAlign: "middle",
                      fontSize: "1.2em",
                      cursor: "pointer",
                    }}
                  >
                    HOME
                  </span>
                </NavLink>
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid>
      </div>

      <div>
        <Grid centered columns={1}>
          <Grid.Column textAlign="center" className="enrollment-grid">
            {props.applicationType === "" ? (
              <div style={{ marginTop: "100px" }}>
                <h3>Select type of application</h3>
                <Button.Group size="huge">
                  <Button onClick={() => props.clickApplication("old")}>
                    Old Student
                  </Button>
                  <Button.Or />
                  <Button
                    positive
                    onClick={() => props.clickApplication("new")}
                  >
                    New Student
                  </Button>
                </Button.Group>
              </div>
            ) : props.applicationType === "old" && !props.student ? (
              <div style={{ marginTop: "40px" }}>
                <h1>Old Student Verification</h1>
                <Grid centered>
                  <Grid.Column width={14}>
                    <Form>
                      <Form.Field>
                        <label>Enter your Student Number OR LRN</label>
                        <Input
                          placeholder="Student Number or LRN"
                          name="verificationId"
                          value={props.verificationId}
                          onChange={props.handleChange}
                        />
                        <p
                          style={{
                            color: "gray",
                            fontSize: "0.9em",
                            marginTop: "5px",
                          }}
                        >
                          You can enter either your Student Number or LRN to
                          automatically get your enrollment data from previous
                          school year.
                        </p>
                      </Form.Field>
                      <Button
                        primary
                        onClick={() =>
                          props.handleVerifyStudent(props.verificationId)
                        }
                      >
                        Verify & Continue
                      </Button>
                      <div style={{ marginTop: "10px" }}>
                        <Icon
                          className="text-link"
                          onClick={() => props.clickApplication("")}
                          name="arrow left"
                        />
                        <span
                          className="text-link"
                          onClick={() => props.clickApplication("")}
                          style={{
                            verticalAlign: "middle",
                            fontSize: "1.2em",
                            cursor: "pointer",
                          }}
                        >
                          Go back to selection of application type
                        </span>
                      </div>
                    </Form>
                  </Grid.Column>
                </Grid>
              </div>
            ) : props.applicationType === "old" && props.student ? (
              <div style={{ marginTop: "40px" }}>
                <h1>Old Student Application</h1>
                <Grid centered>
                  <Grid.Column width={14}>
                    <Message positive>
                      <Message.Header>Student Verified!</Message.Header>
                      <p>
                        Welcome back, {props.student.firstName}! Your
                        information has been loaded.
                      </p>
                      <p>
                        <strong>Student Number:</strong>{" "}
                        {props.student.studentNumber}
                        <br />
                        <strong>LRN:</strong>{" "}
                        {props.student.lrn || "Not available"}
                        <br />
                        <strong>Current Grade Level:</strong>{" "}
                        {props.gradeLevel || "Not available"}
                        <br />
                        <strong>Section:</strong>{" "}
                        {props.section ? props.section.name : "Not available"}
                      </p>
                    </Message>
                    <Icon
                      className="text-link"
                      onClick={() => props.clickApplication("")}
                      name="arrow left"
                    />
                    <span
                      className="text-link"
                      onClick={() => props.clickApplication("")}
                      style={{
                        verticalAlign: "middle",
                        fontSize: "1.2em",
                        cursor: "pointer",
                      }}
                    >
                      Go back to selection of application type
                    </span>
                  </Grid.Column>
                </Grid>
              </div>
            ) : (
              <div style={{ marginTop: "40px" }}>
                <h1>New Student Application</h1>
                <Grid centered>
                  <Grid.Column width={14}>
                    <Icon
                      className="text-link"
                      onClick={() => props.clickApplication("")}
                      name="arrow left"
                    />
                    <span
                      className="text-link"
                      onClick={() => props.clickApplication("")}
                      style={{
                        veticalAlign: "middle",
                        fontSize: "1.2em",
                        cursor: "pointer",
                      }}
                    >
                      Go back to selection of application type
                    </span>
                  </Grid.Column>
                </Grid>
              </div>
            )}
          </Grid.Column>
        </Grid>
        {props.clicked && (
          <Grid centered>
            <Grid.Column width={14}>
              <ApplicantForm
                applicationType={props.applicationType}
                student={props.student}
                nextGradeLevel={props.nextGradeLevel}
              />
            </Grid.Column>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default EnrollmentFormPV;
